import React from 'react';
import { BaseComponentImpl, RoomImpl } from '../../types/implementations';
import { Building, PhotoModel, BlueprintLocation } from '../../types/protocols';
import BlueprintWithMarkers from '../../Components/BlueprintWithMarkers';

interface RoomBlueprintSectionProps {
    currentBlueprint: PhotoModel | undefined;
    currentBlueprintKey: string | undefined;
    roomBlueprintLocation: BlueprintLocation | undefined;
    building: Building;
    room: RoomImpl;
    markerComponents: BaseComponentImpl[];
    selectedComponentKey: string | null;
    /** Heading; "Ritning" by default. A room spanning several levels shows one section per level. */
    title?: string;
    onComponentClick: (key: string) => void;
}

const RoomBlueprintSection: React.FC<RoomBlueprintSectionProps> = ({
    currentBlueprint,
    currentBlueprintKey,
    roomBlueprintLocation,
    building,
    room,
    markerComponents,
    selectedComponentKey,
    title = 'Ritning',
    onComponentClick,
}) => {
    if (currentBlueprint && currentBlueprintKey) {
        return (
            <div>
                <BlueprintWithMarkers
                    blueprint={currentBlueprint}
                    currentBlueprintKey={currentBlueprintKey}
                    building={building}
                    utilities={markerComponents}
                    selectedUtilityKey={selectedComponentKey}
                    onUtilityClick={onComponentClick}
                    title={title}
                    singleRoom={roomBlueprintLocation
                        ? { room: room, blueprintLocation: roomBlueprintLocation }
                        : undefined
                    }
                />
                {!roomBlueprintLocation && (
                    <p style={{ color: '#999', fontSize: '14px', marginTop: '8px' }}>
                        Rummets position ej markerad på ritning
                    </p>
                )}
            </div>
        );
    }

    return (
        <div>
            <h4 style={{ margin: 0, marginBottom: '20px' }}>{title}</h4>
            <div style={{
                width: '100%',
                minHeight: '200px',
                border: '2px dashed #ccc',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fafafa',
            }}>
                <span style={{ color: '#999', fontSize: '16px' }}>Ritning saknas</span>
            </div>
        </div>
    );
};

export default RoomBlueprintSection;
